export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_INSTALLER = 'SET_INSTALLER';
export const UPDATE_INSTALLER = 'UPDATE_INSTALLER';
export const RELOAD_PROFILE = 'GET_CURRENT_PROFILE';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const GET_CURRENT_SCHEDULE = 'GET_CURRENT_SCHEDULE';
export const GET_COMPLETED_SCHEDULE = 'GET_COMPLETED_SCHEDULE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const GET_AVAILABILITY = 'GET_AVAILABILITY';
export const ADD_AVAILABILITY = 'ADD_AVAILABILITY';
export const REMOVE_AVAILABILITY = 'REMOVE_AVAILABILITY';

// Account Actions
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';


// WEBPACK FOOTER //
// ./src/actions/types.jsx